const config = {
    apiHost: process.apiHost,
    // apiHost: process.apiHost + ':8001',
    // pcUrl: 'https://www.idongde.com/'
}

export default config



// WEBPACK FOOTER //
// ./src/api/config.js